<button mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon>translate</mat-icon>
</button>

<mat-menu #menu="matMenu">
  @for (lang of langs | keyvalue; track lang) {
    <button mat-menu-item (click)="useLanguage(lang.key)">
      <span>{{ lang.value }}</span>
    </button>
  }
</mat-menu>
